import { render, staticRenderFns } from "./org-edit-component.vue?vue&type=template&id=5248bd9d"
import script from "./org-edit-component.vue?vue&type=script&lang=ts"
export * from "./org-edit-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports